/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{ "rawString": ".root_22bfad34{background:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";padding:8px}.root_22bfad34.hasMediumDelay_22bfad34{-webkit-animation-delay:300ms;animation-delay:300ms}.root_22bfad34.hasLongDelay_22bfad34{-webkit-animation-delay:500ms;animation-delay:500ms}.content_22bfad34{font-size:12px;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";word-wrap:break-word;overflow-wrap:break-word}.subText_22bfad34{margin:0}\n" }]);
export var root = "root_22bfad34";
export var hasMediumDelay = "hasMediumDelay_22bfad34";
export var hasLongDelay = "hasLongDelay_22bfad34";
export var content = "content_22bfad34";
export var subText = "subText_22bfad34";
//# sourceMappingURL=Tooltip.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib-es2015/components/Tooltip/Tooltip.scss.js
// module id = 658
// module chunks = 0